import React from 'react';
import { ConstructionIcon } from 'lucide-react';
export function DevelopmentNotice() {
  return <section className="py-16 bg-blue-600 text-white" data-id="element-47">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-48">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6" data-id="element-49">
          <ConstructionIcon className="w-8 h-8" data-id="element-50" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-51">
          Platform Currently in Development
        </h2>
        <p className="text-blue-50 text-lg leading-relaxed opacity-90" data-id="element-52">
          BizCloudDesk is currently being prepared for an anticipated launch on
          August 1, 2026. Some tools, services, dashboard features,
          integrations, and onboarding workflows may be released in phases.
          Early access participants will be notified as services become
          available.
        </p>
      </div>
    </section>;
}